import { objectKeyToString } from 'utils/object-key-to-string';
import { invert } from 'lodash';

export const DASHBOARD_ITEM_TYPES = objectKeyToString({
  chart: '',
  unknown: '',
});

export const DASHBOARD_ITEM_MAP_URI_TO_ITEM_TYPE = {
  charts: DASHBOARD_ITEM_TYPES.chart,
};

export const DASHBOARD_ITEM_MAP_ITEM_TYPE_TO_URI = invert(
  DASHBOARD_ITEM_MAP_URI_TO_ITEM_TYPE
);

export const DASHBOARD_ITEM_LOADING_TEXTS = Object.freeze({
  [DASHBOARD_ITEM_TYPES.chart]: 'Loading chart...',
});

export default {
  DASHBOARD_ITEM_TYPES,
  DASHBOARD_ITEM_MAP_URI_TO_ITEM_TYPE,
  DASHBOARD_ITEM_MAP_ITEM_TYPE_TO_URI,
  DASHBOARD_ITEM_LOADING_TEXTS,
};
